import { Stack, Typography } from "@mui/material";
import { memo, useEffect, useState } from "react";

import { IListIDashboard } from "../../../../models/dashboard";

interface IDashBoardModalItemProps {
  data: IListIDashboard;
  loading: boolean;
  onClick: (data: IListIDashboard) => void;
}

const DashBoardModalItem: React.FC<IDashBoardModalItemProps> = ({
  data,
  loading,
  onClick,
}) => {
  const [disable, setDisable] = useState(false);

  const onClickHandler = () => {
    setDisable(true);
    onClick(data);
  };

  useEffect(() => {
    return () => {
      setDisable(false);
    };
  }, []);

  return (
    <Stack
      padding={2}
      direction={"row"}
      gap={2}
      sx={(t) => ({
        cursor: "pointer",
        borderRadius: 1,
        opacity: loading ? 0.5 : 1,
        "&:hover": {
          backgroundColor: t.palette.divider,
        },
      })}
      key={data.id}
      onClick={loading || disable ? undefined : onClickHandler}
    >
      <Typography>{data.name}</Typography>
    </Stack>
  );
};

export default memo(DashBoardModalItem);
